import type { ModuloChecklist } from '@hooks/useChecklistGeral.js'

/** Alerta PERT: avisa quando há módulo em andamento sem concluir anteriores. */
export function computeAlertaSequencia(modulos: ModuloChecklist[]): string | null {
  const sorted = [...modulos].sort((a, b) => a.ordem - b.ordem)
  for (let i = 1; i < sorted.length; i++) {
    const atual = sorted[i]!
    if (atual.status === 'nao-iniciado') continue
    const pendentes = sorted.slice(0, i).filter((m) => m.status === 'nao-iniciado')
    if (pendentes.length > 0) {
      const nomes = pendentes.map((m) => m.titulo).join(', ')
      return `Você avançou em "${atual.titulo}" sem concluir etapas anteriores: ${nomes}. Seguir a ordem do guia evita retrabalho caro.`
    }
  }
  return null
}
